import { takeEvery, takeLatest } from 'redux-saga';
import { call, put } from 'redux-saga/effects';
import { FACEBOOK_LOAD, facebookLoaded } from 'es6/redux/modules/auth/facebook';
import { OPEN_CLIENT } from 'es6/redux/modules/auth/oauth';
import { load } from 'es6/services/facebook';

// Client window key for opening popups.
const CLIENT_WINDOW_KEY = 'IKNOW_OAUTH';

function* openClient(action) {
  const { height, width, path } = action;
  window.open(path, CLIENT_WINDOW_KEY, `width=${width},height=${height},resizable=yes`);
  window.focus();
}

function* facebookLoad() {
  yield call(load);
  yield put(facebookLoaded());
}

export default function* watchRegistrationActions() {
  yield [
    takeEvery(OPEN_CLIENT, openClient),
    takeLatest(FACEBOOK_LOAD, facebookLoad),
  ];
}
